import LazyImage from './lazy-image'

export const AmuiLazyImage = LazyImage

export default Vue => Vue.component(LazyImage.name, LazyImage)
